import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => ({
  loading: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 16,
    [theme.media.phone]: { gridTemplateColumns: "1fr" }
  },
  skeleton: {
    aspectRatio: "1025 / 341",
    height: "auto !important",
    minHeight: 100,
    borderRadius: `${theme.tokens.radius.card}px !important`
  }
}));

export default withCustomStyles;
